var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",style:({ background: _vm.arry[_vm.index].colorType })},[_vm._v("\n  "+_vm._s(_vm.arry[_vm.index].alarmType)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }